import { Loader2 } from "lucide-react";

type LoadingProps = {
  label: string;
};

export const Loading = (props: LoadingProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <Loader2 className="h-12 w-12 animate-spin text-emerald-600" />
      <p className="text-lg font-medium text-gray-700">{props.label}</p>
    </div>
  );
};
